import toLower from 'lodash/toLower'
import MemoryStore from '../utils/memory-store'
import Enums from '../utils/enums'
import EventsFormContainer from '../events/containers/events-form-container'

export const filterViewData = (viewData, searchFilter) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return viewData
  } else {
    return viewData.filter(
      t =>
        t.data.key.toLowerCase().indexOf(searchFilter) > -1 ||
        t.data.description.toLowerCase().indexOf(searchFilter) > -1
    )
  }
}

export const filterSubscriptionsViewData = (data, searchFilter, callback) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return callback(data)
  } else {
    return callback(
      data.filter(
        t =>
          t.name.toLowerCase().indexOf(searchFilter) > -1
      )
    )
  }
}

export const getLinkedProfiles = callback => {
  MemoryStore.agilite.BatchLogging.getData()
    .then((response) => {
      callback(null, response)
    })
    .catch((error) => {
      callback(error, null)
    })
}

export const formatRecord = (entry, data) => {
  let tempIndex = 0

  entry.data.key = toLower(entry.data.key.split(' ').join(''))
  entry.data.description = entry.data.description.trim()

  if (entry.data.isActive !== undefined) {
    entry.data.isActiveDescription = entry.data.isActive ? 'Yes' : 'No'
  }

  if (entry.custom.isNewDoc) {
    // Add new Entry to State
    entry.custom.isNewDoc = false
    entry.custom.action = 'create'
    data.push(entry)
  } else {
    if (entry.custom.isSavedDoc) {
      entry.custom.action = 'update'
    } else {
      entry.custom.action = 'create'
    }

    // Update Entry in State
    tempIndex = data.findIndex(t => t._id === entry._id)
    data[tempIndex] = entry
  }

  return data
}

export const getAPIKeys = callback => {
  MemoryStore.agilite.ApiKeys.getData()
    .then((response) => {
      callback(null, response)
    })
    .catch((error) => {
      callback(error, null)
    })
}

export const getTeamUsers = callback => {
  MemoryStore.agilite.executeCRUDRequest(Enums.APP_IDS.TEAM_USERS, Enums.REQ_TYPE.GET)
    .then((response) => {
      callback(null, response)
    })
    .catch((error) => {
      callback(error, null)
    })
}

export const createCopy = (currEntryData, callback) => {
  const newEntry = JSON.parse(JSON.stringify(MemoryStore.events.dataTemplate))
  newEntry._id = new Date().getTime().toString()
  newEntry.custom.tempId = newEntry._id

  const entryData = JSON.parse(JSON.stringify(currEntryData))
  const tabType = Enums.VALUES_STRINGS.FORM
  const content = EventsFormContainer
  const closable = true
  const key = newEntry._id
  const app = Enums.APP_IDS.EVENTS

  let title = Enums.APP_PROFILE_TITLES.events + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE
  let payload = {}

  // create unique key
  entryData.key = currEntryData.key + '_copy'

  newEntry.data = entryData

  title += entryData.key

  payload = {
    content,
    title,
    key,
    app,
    tabType,
    closable
  }

  MemoryStore.activeEntries[newEntry._id] = newEntry

  callback(payload)
}
